const config = {
  showReferralMidwife: false,
  showMidwife: true,
  showMeSignUp: false,
}

export default config
